import { render, staticRenderFns } from "./FrequentQuestions.vue?vue&type=template&id=7aa9952a&scoped=true&"
import script from "./FrequentQuestions.vue?vue&type=script&lang=js&"
export * from "./FrequentQuestions.vue?vue&type=script&lang=js&"
import style0 from "./FrequentQuestions.vue?vue&type=style&index=0&id=7aa9952a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa9952a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7aa9952a')) {
      api.createRecord('7aa9952a', component.options)
    } else {
      api.reload('7aa9952a', component.options)
    }
    module.hot.accept("./FrequentQuestions.vue?vue&type=template&id=7aa9952a&scoped=true&", function () {
      api.rerender('7aa9952a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/FrequentQuestions.vue"
export default component.exports